import { BASE_URL } from "../environment";
import makeRequest from "../makeRequest";

export async function fetchVodafoneOrders(searchTerm = "", status = "") {
  const params = new URLSearchParams();
  if (searchTerm) params.set("searchTerm", searchTerm);
  if (status) params.set("status", status);

  const query = params.toString() ? `?${params}` : "";
  return makeRequest(`${BASE_URL}/vodafonesearchorders${query}`);
}

export async function declineVodafoneOrder(reference) {
  return makeRequest(`${BASE_URL}/vodafonesearchorders?decline-order=true`, {
    method: "POST",
    body: JSON.stringify({ Reference: reference }),
  });
}

export async function fetchVodafoneNotifications(reference = "") {
  const query = reference ? `?reference=${encodeURIComponent(reference)}` : "";
  return makeRequest(`${BASE_URL}/vodafonenotifications${query}`);
}
